<template>
  <v-container class="fill-height light align-start" fluid light mt-0 pt-0 id="top">
    <v-row class="wrap d-flex justify-center mt-0 pt-0">
      <v-col cols="12" class="mt-0 pt-0" align-start>
        <v-row class="d-flex wrap justify-center align-center">
          <v-col class="ma-0 pa-0">
            <v-snackbar
              v-model="noProjects"
              :timeout="7000"
              top
              xlarge
              color="deep-orange darken-3 white--text"
              dark
            >
              Pas encore de projet d'aide, créez en un !
              <br />Où partager le site à des associations dans le besoin
              <v-btn color="white" text @click="noProjects = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-snackbar>
            <v-img
              class="ma-0 pa-0"
              :aspect-ratio="16/9"
              max-height="400px"
              src="../assets/images/hero.png"
              gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
            >
              <v-row class="d-flex justify-center align-center white--text fill-height">
                <v-col cols="12">
                  <h1
                    class="white--text text-center display-2 ma-4 pa-4"
                  >Je veux aider et être utile aux autres</h1>
                  <v-row
                    class="d-flex justify-center align-center align-content-center white--text"
                  >
                    <v-flex lg4 md6 sm8 xs10>
                      <v-select
                        light
                        v-model="need"
                        :items="needs"
                        item-value="need"
                        item-text="examples"
                        :two-line="true"
                        label="Choisissez comment vous souhaitez aider"
                        solo
                        append-icon="mdi-plus"
                        color="deep-orange darken-3"
                        @input="search()"
                        :loading="loading"
                      >
                        <template slot="selection" slot-scope="data">
                          <!-- HTML that describe how select should render selected items -->
                          {{ data.item.need }}
                        </template>
                        <template slot="item" slot-scope="data">
                          <!-- HTML that describe how select should render items when the select is open -->
                          <v-list>
                            <v-list-item-title class="deep-orange--text darken-3" v-html="data.item.need"></v-list-item-title>
                            <v-list-item-content v-html="data.item.examples"></v-list-item-content>
                            <v-divider></v-divider>
                          </v-list>
                        </template>
                      </v-select>
                    </v-flex>
                  </v-row>
                </v-col>
              </v-row>
            </v-img>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-if="projects.length !== 0" class="wrap d-flex justify-center mt-0 pt-0">
      <v-col lg="8" sm="12" md="10">
        <v-row>
          <v-col v-for="(item, i) in projects" :key="i" cols="12">
            <v-card elevation-1 mx-auto>
              <v-card-title>
                <div v-text="item.title"></div>
                <v-spacer></v-spacer>
                <div class="card-need">
                  <v-icon class="text-color mr-2">mdi-tag</v-icon>
                  <span v-text="item.need"></span>
                </div>
              </v-card-title>
              <v-card-subtitle class="font-weight-light">{{ getDateWithTimestamp(item.timestamp)}}</v-card-subtitle>
              <v-divider />
              <v-card-text v-html="item.presentation"></v-card-text>
              <v-divider />
              <v-card-actions text-center>
                <div v-if="item.email">
                  <v-icon>mdi-mail</v-icon>
                  <span class="ml-1" v-html="item.email"></span>
                </div>
                <v-spacer></v-spacer>
                <div v-if="item.phone && item.phone != '0123456789'">
                  <v-icon>mdi-phone</v-icon>
                  <span v-html="item.phone"></span>
                </div>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row v-else class="d-flex w-rap justify-center align-start fill-height">
      <v-layout column wrap>
        <v-flex>
          <v-flex>
            <h2 class="text-color text-center myh2 ma-4 comfortaa">Pourquoi cette application ?</h2>
          </v-flex>
          <v-flex row pa-3 class="d-flex w-rap justify-center align-start">
            <v-flex lg5 md6 sm8 xs12 pa-2 d-flex justify-start>
              <v-timeline dense class="ma-4">
                <v-timeline-item
                  :fill-dot="true"
                  :small="true"
                  color="red lighten-2"
                  right
                >
                  <v-card class="elevation-3">
                    <v-card-title
                      class="deep-orange darken-3 white--text pa-2 text-center"
                    >Constat</v-card-title>
                    <v-card-text
                      class="card-timeline pa-2 text-justify"
                    >Crise sanitaire, sociétale, écologique, économique</v-card-text>
                  </v-card>
                </v-timeline-item>
                <v-timeline-item
                  :fill-dot="true"
                  :small="true"
                  color="orange lighten-2"
                  right
                >
                  <v-card class="elevation-3">
                    <v-card-title
                      class="orange lighten-2 white--text pa-2 text-center"
                    >Conséquences</v-card-title>
                    <v-card-text
                      class="card-timeline pa-2 text-justify"
                    >Colère, sentiment d'impuissance, d'inutilité</v-card-text>
                  </v-card>
                </v-timeline-item>
                <v-timeline-item
                  :fill-dot="true"
                  :small="true"
                  right
                  color="pink lighten-2"
                >
                  <v-card class="elevation-3">
                    <v-card-title
                      class="pink lighten-2 white--text pa-2 text-center"
                    >Réaction positive</v-card-title>
                    <v-card-text
                      class="card-timeline pa-2 text-justify"
                    >Je veux aider les autres mais comment faire ?</v-card-text>
                  </v-card>
                </v-timeline-item>
                <v-timeline-item
                  :fill-dot="true"
                  :small="true"
                  right
                  color="green lighten-2"
                >
                  <v-card class="elevation-3">
                    <v-card-title
                      class="white--text green lighten-2 pa-2 text-center"
                    >Je passe à l'action</v-card-title>
                    <v-card-text
                      class="card-timeline pa-2 text-justify"
                    >
                      Cette application est l'une des réponses au besoin d'aider les autres.
                      <br />Elle permet simplement de mettre en lien les créateurs d'un projet d'aide avec ceux qui cherchent à être utile et à aider les autres (personne civile, association ou toutes autres initiatives)
                    </v-card-text>
                  </v-card>
                </v-timeline-item>
              </v-timeline>
            </v-flex>

            <v-flex lg4 md8 sm8 xs12 pl-3 mt-5 mb-5 d-flex justify-center align-self-center>
              <v-img max-width="100%" contain src="../assets/images/illusHome.png"></v-img>
            </v-flex>
          </v-flex>
        </v-flex>

        <v-flex class="deep-orange darken-3 d-flex justify-center align-center flex-column w-rap fill-height">
          <v-flex lg10 md12 sm12 xs12>
            <h2 class="white--text text-center myh2 ma-4 comfortaa">Comment ça marche ?</h2>
          </v-flex>
          <v-flex lg10 md12 sm12 xs12 d-flex justify-center>
            <v-flex lg10 md8 sm12 xs12 pa-2 mb-4>
              <v-btn x-large depressed rounded class="mb-4 deep-orange--text darken-3" color="white" href="#top">Je veux aider</v-btn>
              <p class="white--text">
                <strong class="white--text">Pas besoin d'inscription pour être utile aux autres</strong>, sélectionnez simplement le type d'aide que vous souhaitez apporter dans le menu déroulant.
              </p>
              <p class="white--text">
                Les projets s'afficheront à la place de cette présentation.
              </p>
              <p class="white--text">
                La plateforme est encore jeune, il est possible qu'il n'y ait pas encore de projet, n'hésitez pas à faire connaître cette plateforme auprès des association ou porteur de projet d'aide.
              </p>
            </v-flex>
          </v-flex>
        </v-flex>
        <v-flex class="d-flex justify-center align-center flex-column w-rap fill-height">
          <v-flex lg10 md12 sm12 xs12 pa-2>
            <h2 class="deep-orange--text darken-3 text-center myh2 ma-4 comfortaa">Besoin de bénévole ?</h2>
          </v-flex>
          <v-flex lg10 md8 sm12 xs12 d-flex justify-center>
            <v-flex lg10 md8 sm12 xs12 pa-2>
              <p class="grey-dark-text">
                <strong class="grey-dark-text">Vous êtes un porteur de projet commun (association, particulier) </strong>à la recherche de personnes aidantes, vous êtes au bon endroit.<br>
              </p>
              <p class="ml-3">
                1 . Inscrivez-vous gratuitement, puis connectez-vous.
              </p>
              <p class="ml-3"> 
                2 . Ajoutez votre projet en complétant le formulaire dédié. Il est important de bien détailler votre projet, le besoin, fonctionnement, etc.
              </p>
              <p class="ml-3">
                3 . Enregistrer! Le projet est instantanément visible sur l'accueil pour les aidants. Il est possible de dépublier ou supprimer votre projet par la suite. Vous pouvez ajouter autant de projets que vous le souhaitez.
              </p>
              <v-flex d-flex justify-center>
                <v-btn x-large center depressed rounded class="white--text mb-4" color="deep-orange darken-3" to="/register">J'ajoute un projet d'aide</v-btn>
              </v-flex>
            </v-flex>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import needsJson from "../data/needs.json";
export default {
  name: "Home",
  data() {
    return {
      need: "",
      needs: needsJson,
      noProjects: false
    };
  },
  methods: {
    getDateWithTimestamp(timestamp) {
      let todate = new Date(timestamp).getDate();
      if (todate < "10") {
        todate = "0" + todate;
      }
      let tomonth = new Date(timestamp).getMonth() + 1;
      if (tomonth < "10") {
        tomonth = "0" + tomonth;
      }
      let toyear = new Date(timestamp).getFullYear();
      let date = todate + "-" + tomonth + "-" + toyear;
      return date;
    },
    async search() {
      await this.$store.dispatch("search", { need: this.need }).then(() => {
        if (this.projects[0] !== undefined) {
          this.noProjects = false;
        } else {
          this.noProjects = true;
        }
      });
    }
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters({
      error: "error",
      user: "user",
      projects: "projects",
      loading: "loading"
    })
  }
};
</script>
<style scoped>
* {
  color: #666;
}
.bg-color {
  background-color: #D85D19;
}
.text-color {
  color: #D85D19;
}
.card-need {
  font-size: 0.8em;
  text-align: right;
  font-weight: 400;
}
.card-timeline {
  font-size: 0.9em;
  text-align: left;
  font-weight: 500;
  color: #666;
}
</style>
